<template>
  <div class="">

    <button class="btn d-print-none btn-primary" @click="printPages()">
      <b-icon-printer/>
      پرینت
    </button>

    <div class="page" v-for="user in users" :key="user.id">
      <div class="image-container">
        <img src="/form300QuestionTemplate.jpg" alt="Image 3">
        <div class="text-overlay">
          <div class="col-12">
            <div class="row align-items-center">
              <div class="col-6">
                <p>نام نام خانوادگی: {{ user.name }} {{ user.last_name }}</p>
              </div>
              <div class="col-6 text-center" id="print-course-form">
                <vue-qr  :size="500" class="qrTag" ref="qrTag" :text="$route.params.form"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue'

export default {
  name: "PrintCourseForm",
  components: {vueQr},
  data() {
    return {
      users: []
    }
  },
  methods: {
    async loadUsers() {
      // let form = this.$route.params.form
      let product = this.$route.params.product
      let form = {
        product_id: product
      }
      let req = await this.$store.dispatch('Product/getProductUsers', form)
      this.users = req.data.data;
    },
    printPages(){
      window.print()
    }
  },
  mounted() {
    this.loadUsers()
  }
}
</script>

<style scoped>

@media print {
  /* Ensure A4 size */
  @page {
    size: A4 portrait;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }

  /* Each page will contain one image */
  .page {
    page-break-after: always;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw; /* Full viewport width */
    height: 100vh; /* Full viewport height */
    box-sizing: border-box;
  }

  /* Ensure images fit inside the page */
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
}

/* For preview in normal browser view */
.page {
  margin: 50px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* Container to hold image and text */
.image-container {
  position: relative;
  display: inline-block;
}

/* Text overlay on the image */
.text-overlay {
  position: absolute;
  top: 20px;
  right: 36px;
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
  width: 90%;
}


</style>

<style>
#print-course-form img {
  width: 150px;
  height: 150px;
}
</style>